import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Participant.css';

const CompletePage = () => {
  const { sessionId } = useParams();

  return (
    <div className="participant-container">
      <div className="participant-card branded-card">
        <div className="success-icon">✓</div>
        <h1>Thank You!</h1>
        <p className="subtitle">
          Your screening has been completed successfully.
        </p>
        <p className="message">
          We have received your responses and will review them shortly.
          You will be contacted if you proceed to the next stage.
        </p>
      </div>
    </div>
  );
};

export default CompletePage;

